<div id="{{message.id}}" class="message-item" [@showHide]="isShown ? 'show' : 'hide'" (@showHide.done)="showHideDone()">
  <div class="delete-message">
    <aa-action-circle class="blue duotone" [faIcon]="'fal fa-times'" (click)="deleteMessage()"></aa-action-circle>
  </div>
  <div class="icon">
    @switch (message.iconClass) {
      @case ('info') {
        <aa-icon-circle class="info duotone" [faIcon]="message.icon" [size]="'fa-2x'">
        </aa-icon-circle>
      }
      @case ('success') {
        <aa-icon-circle class="success duotone" [faIcon]="message.icon" [size]="'fa-2x'">
        </aa-icon-circle>
      }
      @case ('warning1') {
        <aa-icon-circle class="warning1 duotone" [faIcon]="message.icon" [size]="'fa-2x'">
        </aa-icon-circle>
      }
      @case ('warning2') {
        <aa-icon-circle class="warning2 duotone" [faIcon]="message.icon" [size]="'fa-2x'">
        </aa-icon-circle>
      }
      @case ('danger') {
        <aa-icon-circle class="danger duotone" [faIcon]="message.icon" [size]="'fa-2x'">
        </aa-icon-circle>
      }
    }
  </div>
  <table>
    <tr>
      <td class="title">
        {{message.title}}
      </td>
    </tr>
    <tr>
      <td class="message">
        {{message.message}}
      </td>
    </tr>
  </table>
</div>
